export default __webpack_public_path__ + "static/media/SemanaNordica_Agenda_Jueves_scroll.37d0fd04.png";